import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { filter, map, tap, withLatestFrom, debounceTime } from 'rxjs/operators';
import { DisplayMessageMinimum } from '../../../common';
import * as fromShared from '../../../shared';
import { ResponseStatus } from '../../../shared';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { GlobalErrorDialogService } from '../../services/global-error-dialog.service';
import * as actions from './actions';
import { State } from './reducers';

@Injectable()
export class ErrorEffects {
    constructor(
        private log: LoggingService,
        private actions$: Actions,
        private store: Store<State>,
        private globalErrorDialogService: GlobalErrorDialogService
    ) {}

    SetErrors$ = createEffect(() =>
        this.actions$
            .pipe(
                ofType<actions.SetErrors>(
                    actions.ErrorsSidenavActionTypes.SetErrors
                )
            )
            .pipe(
                withLatestFrom(this.store.pipe(select(fromShared.selectAll))),
                map(
                    ([action, processes]) =>
                        new fromShared.Errors.SetErrorsForProcess({
                            errors: action.payload,
                            processId: processes[0] && processes[0].ProcessID
                        })
                )
            )
    );
    ErrorDialog$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType<actions.SetErrors>(
                    actions.ErrorsSidenavActionTypes.SetErrors
                ),
                filter(action =>
                    action.payload
                        .filter(x => !!x)
                        .some(
                            x =>
                                !(x.MsgEntityID && x.MsgProcessID) &&
                                x.StatusCode >= DisplayMessageMinimum
                        )
                ),
                debounceTime(100),
                tap(action => {
                    const maxStatus = action.payload.reduce(
                        (a, c) => (c.StatusCode > a ? c.StatusCode : a),
                        ResponseStatus.Success
                    );
                    
                    const errorMessage = action.payload.find(
                        x => !(x.MsgEntityID && x.MsgProcessID)
                    )?.Message || 'An error occurred';

                    this.globalErrorDialogService.showError(errorMessage, maxStatus);
                })
            ),
        { dispatch: false }
    );
}
